import { render, staticRenderFns } from "./TrashedTasks.vue?vue&type=template&id=0d8ea5de&"
import script from "./TrashedTasks.vue?vue&type=script&lang=js&"
export * from "./TrashedTasks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports